import { Component, inject } from '@angular/core';
import { ResponsiveService } from '../services/responsive';
import { regwallActions } from '../services/regwall-actions';

@Component({
  selector: 'app-regwall-info',
  templateUrl: './regwall-info.html',
  styleUrl: './regwall-info.scss',
  standalone: true,
  imports: [],
})
export class RegwallInfo {
  private readonly actions = regwallActions();
  readonly responsive = inject(ResponsiveService);

  onSignup(): void {
    this.actions.onSignup();
  }

  onLogin(): void {
    this.actions.onLogin();
  }
}
